

import { Component, Prop, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

@Component
export default class Layout extends Vue {
  @Prop({ default: 'Default' }) name!: string;
  @Mutation('SET_LAYOUT') setLayout!: (layout: string) => any;

  toPascalCase(str: string) {
    return str.replace(/\w\S*/g, (m) => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase());
  }

  created() {
    // Check if the layout component
    // has already been registered.
    const fileName = this.toPascalCase(this.name) + 'Layout';

    if (!(Vue as any).options.components[fileName]) {
      Vue.component(fileName, () => import(`../layouts/${fileName}.vue`));
    }

    this.setLayout(fileName);
  }

  render(createElement: any) {
    if (this.$slots.default) {
      return createElement(
        'div',
        {
          class: {
            'layout-wrapper': true,
          },
        },
        this.$slots.default,
      );
    } else {
      return createElement('div');
    }
  }
}
